/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { CreateMatrixCarePatient201ResponseData } from './CreateMatrixCarePatient201ResponseData';
import {
    CreateMatrixCarePatient201ResponseDataFromJSON,
    CreateMatrixCarePatient201ResponseDataFromJSONTyped,
    CreateMatrixCarePatient201ResponseDataToJSON,
} from './CreateMatrixCarePatient201ResponseData';

/**
 * 
 * @export
 * @interface CreateMatrixCarePatient201Response
 */
export interface CreateMatrixCarePatient201Response {
    /**
     * 
     * @type {CreateMatrixCarePatient201ResponseData}
     * @memberof CreateMatrixCarePatient201Response
     */
    data?: CreateMatrixCarePatient201ResponseData;
}

/**
 * Check if a given object implements the CreateMatrixCarePatient201Response interface.
 */
export function instanceOfCreateMatrixCarePatient201Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function CreateMatrixCarePatient201ResponseFromJSON(json: any): CreateMatrixCarePatient201Response {
    return CreateMatrixCarePatient201ResponseFromJSONTyped(json, false);
}

export function CreateMatrixCarePatient201ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateMatrixCarePatient201Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : CreateMatrixCarePatient201ResponseDataFromJSON(json['data']),
    };
}

export function CreateMatrixCarePatient201ResponseToJSON(value?: CreateMatrixCarePatient201Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': CreateMatrixCarePatient201ResponseDataToJSON(value.data),
    };
}

